import React from "react";
import {Modal} from "react-bootstrap";
import {SpinnerWrapper} from "../common/SpinnerWrapper";
import {formatSummaryCategory, formatSummaryDate, sanitizeSummaryHtml, SummaryCopyButton} from "../common/patient/PatientChartSummaryList";

export class InterimSummaryModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {selectedId: null};
    }

    componentDidMount() {
        this.selectFirst();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.loading && !this.props.loading) {
            this.selectFirst();
        }
    }

    selectFirst() {
        const first = (this.props.summaries || [])[0];
        this.setState({selectedId: first ? first.id : null});
    }

    selectedSummary() {
        const summaries = this.props.summaries || [];
        return summaries.find(summary => summary.id === this.state.selectedId) || null;
    }

    render() {
        const summaries = this.props.summaries || [];
        const selected = this.selectedSummary();
        return <Modal show={this.props.show} onHide={this.props.onHide} size="xl" className="no-print" backdropClassName="no-print">
            <Modal.Header closeButton>
                <Modal.Title>Interim Summary</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
                <SpinnerWrapper visible={this.props.loading}>
                    {summaries.length === 0 ? <div className="p-3">No summaries found</div> :
                        <div className="interim-summary-layout">
                            <div className="interim-summary-list">
                                {summaries.map(summary => {
                                    const active = selected && summary.id === selected.id;
                                    return <button type="button" key={summary.id}
                                                    className={"interim-summary-item" + (active ? " active" : "")}
                                                    aria-pressed={active}
                                                    onClick={() => this.setState({selectedId: summary.id})}>
                                        <div>{formatSummaryCategory(summary.category)}</div>
                                        <div className="text-muted small">{formatSummaryDate(summary.createdAt)}</div>
                                    </button>;
                                })}
                            </div>
                            <div className="interim-summary-body">
                                {selected && <>
                                    <SummaryCopyButton html={selected.body} patient={this.props.patient} key={selected.id}/>
                                    <div dangerouslySetInnerHTML={{__html: sanitizeSummaryHtml(selected.body)}}/>
                                </>}
                            </div>
                        </div>
                    }
                </SpinnerWrapper>
            </Modal.Body>
        </Modal>;
    }
}
